// extracted by mini-css-extract-plugin
export var authorNameStyle = "quote_small_left_aligned-module--authorNameStyle--Jc2zm";
export var clientLogoStyle = "quote_small_left_aligned-module--clientLogoStyle--GmIXW";
export var isXLStyle = "quote_small_left_aligned-module--isXLStyle--GJNfg";
export var quoteAttributionStyle = "quote_small_left_aligned-module--quoteAttributionStyle--FpaqV";
export var quoteBodyStyle = "quote_small_left_aligned-module--quoteBodyStyle--M3WnO";
export var textColorDarkStyle = "quote_small_left_aligned-module--textColorDarkStyle--lQYsP";
export var textColorLightStyle = "quote_small_left_aligned-module--textColorLightStyle--a7-bF";